export function dateExactMatcher(date1, date2) {
  // date1 is a string in formate dd/mm and date2 is in date formate
  // we return true if both dates are same
  //console.log(typeof date2);
  // console.log(date2);
  date2 = new Date(date2.split("T")[0]);
  //console.log(date1);
  date1 = date1.split("/").reverse().join("/");

  let d = new Date();
  let year = d.getFullYear().toString();

  let date = new Date(`${date1}/${year}`);
  // console.log(date.toDateString());

  //let d1 = new Date(`${year}/${t}`);
  let d1 = new Date(`${date1}/${year}`);
  //console.log(d1);
  let d2 = new Date(date2);

  if (d1.toDateString() == date2.toDateString()) {
    return true;
  } else return false;
}
